var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{staticClass:"pa-5 my-7 mr-2"},[_c('span',{staticClass:"text-body-2 font-weight-medium"},[_c('div',[_vm._v(" "+_vm._s(_vm.$i18n.t(_vm.translationPath))+" ")]),_c('div',[_vm._v(" "+_vm._s(_vm.value)+" "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.unit)}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }